import Vue from 'vue'
import VueRecaptcha from 'vue-recaptcha'

Vue.component('VueRecaptcha', {
  extends: VueRecaptcha,
  props: {
    loadRecaptchaScript: {
      type: Boolean,
      default: true,
    },
    recaptchaHost: {
      type: String,
      default: 'www.recaptcha.net',
    },
  },
})
